import { useContext } from "react";
import {
  ConversationContext,
  ConversationHubContextProps,
} from "../providers/ConversationHubProvider";

export const useConversationHub = (): ConversationHubContextProps => {
  const context = useContext(ConversationContext);
  if (!context) {
    throw new Error(
      "useConversationHub must be used within a ConversationHubProvider"
    );
  }

  return context;
};
